// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Q5wg","questions":"styles_questions__Nw2aT","footer":"styles_footer__2sw6U"};